import { useFormikContext } from "formik";
import { removeAccents } from "helpers";
import useFormikError from "hooks/useFormikError";
import React from "react";
import { inputClass } from "./InputBase";

interface Props {
  name: string;
  placeholder?: string;
  disabled?: boolean;
}

const InputSlug: React.FC<Props> = ({ disabled, name, placeholder }) => {
  const error = useFormikError(name);
  const { setFieldValue, getFieldProps, setFieldTouched } = useFormikContext();
  const fieldProps = getFieldProps(name);

  const handleSlugChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    const last = value.slice(-1);
    if (last === "-") {
      value = value.slice(0, -1);
    }

    const slug = removeAccents(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .slice(0, 50);

    if (last === " ") {
      setFieldValue(name, slug + " ");
    } else setFieldValue(name, slug);
  };
  return (
    <input
      type="text"
      disabled={disabled}
      className={inputClass(!!error, false)}
      placeholder={placeholder}
      value={fieldProps.value}
      onChange={handleSlugChange}
      onBlur={() => setFieldTouched(name)}
    />
  );
};

export default InputSlug;
